import { OverlayRef } from '@angular/cdk/overlay';
import { ComponentRef, EventEmitter } from '@angular/core';
import { SideDialogOptions } from './side-dialog-options.class';

export class SideDialogRef<R = unknown, T = unknown> {
  opened = new EventEmitter<void>();
  closed = new EventEmitter<R | void>();

  readonly componentInstance: T;

  readonly componentRef: ComponentRef<T>;

  private _overlay: OverlayRef;
  public get overlayRef(): OverlayRef {
    return this._overlay;
  }

  private _options: SideDialogOptions;
  public get options(): SideDialogOptions {
    return this._options;
  }

  constructor(overlay: OverlayRef, options: SideDialogOptions) {
    this._overlay = overlay;
    this._options = options;

    if (!this._options.disableClose) {
      this._overlay.backdropClick().subscribe(() => this.close());

      this._overlay.keydownEvents().subscribe((event) => {
        if (event.key === 'Escape') {
          this.close();
        }
      });
    }
  }

  public close(results?: R): void {
    this.closed.emit(results);

    this._overlay.overlayElement?.classList.add('side-dialog-panel__closing');
    this._overlay.backdropElement?.style.setProperty('opacity', '0');

    setTimeout(() => {
      this._overlay.detach();
      this._overlay.dispose();
    }, 400);
  }
}
